import { LOGIN_REQUEST, LOGIN_ERROR } from '../constants/ActionTypes';
import { timeout, delay } from '@ynap/promise-utils';
import { Identity, ResponseError, nativeAppHeaders } from '@ynap/api-utils';
import setUberToken from './setUberToken';
import { dispatchUserChangeEvent, redirectToUrl, tmHeadersParams } from './utils';

function loginRequest() {
    return {
        type: LOGIN_REQUEST,
    };
}

function loginError(error) {
    return {
        type: LOGIN_ERROR,
        error,
    };
}

// eslint-disable-next-line no-unused-vars
export default function login(credentials, form = 'login', requestDelay, redirect, successCallback) {
    return (dispatch, getState, wcsFetch) => {
        const { locale, config, router, uberToken, deviceType } = getState();
        const { location = {} } = router;
        const { query = {} } = location;
        const { country } = locale;
        const { clientRequest } = config.head;
        const { baseUrl, clientId, clientSecret } = config.global.services.commerce;
        const { brandId } = config.global.application;
        const { affiliate, tmSessionId, tmEnabled = false, ...params } = credentials;

        if (affiliate) {
            params.loginPage = 'amex';
        }

        if (params.externalConsentsProvided) {
            params.externalConsentsProvided = 'true';
        }

        const additionalHeaders = {
            ...nativeAppHeaders(deviceType),
            ...(tmEnabled && tmHeadersParams('login', { logonId: credentials.logonId, sessionId: tmSessionId, country, deviceType }, config)),
        };

        const request = Identity.login({ baseUrl, brandId, country, credentials: params, clientId, clientSecret, uberToken, additionalHeaders });

        dispatch(loginRequest());

        function uberTokensDispatch(user) {
            dispatch(setUberToken(user.Ubertoken));
            dispatchUserChangeEvent(user.Ubertoken);
        }

        return delay(timeout(wcsFetch(request), clientRequest.timeout), requestDelay || clientRequest.delay)
            .then((response) => {
                const { ok } = response;
                if (ok) {
                    successCallback?.();
                    return response
                        .json()
                        .then((json) => {
                            uberTokensDispatch(json);
                            window.parent.postMessage({ type: 'updateUbertoken', uberToken: json.Ubertoken }, '*');
                            return json.Ubertoken;
                        })
                        .then((token) => {
                            const { iframe = 'false' } = query;
                            window?.SF?.notifyUserChange({uberToken: token, reset: true})
                            
                            if (iframe !== 'true' || !iframe) {
                                redirectToUrl(redirect, location, locale);
                            }
                        });
                }
                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(loginError(error));
                throw error;
            });
    };
}